import {
  FETCH_VEHICLES_REQUEST,
  FETCH_VEHICLES_SUCCESS,
  FETCH_VEHICLES_FAILURE,
  UPDATE_VEHICLE_STATUS_REQUEST,
  UPDATE_VEHICLE_STATUS_SUCCESS,
  UPDATE_VEHICLE_STATUS_FAILURE,
} from '../actions/types';

const initialState = {
  vehicles: [],
  loading: false,
  error: null,
  message: '',
};

// Reducer for handling vehicle actions
export default function vehicleReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VEHICLES_REQUEST:
    case UPDATE_VEHICLE_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_VEHICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicles: action.payload,
        message: 'Vehicles loaded successfully',
      };

    case FETCH_VEHICLES_FAILURE:
    case UPDATE_VEHICLE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_VEHICLE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicles: Array.isArray(state.vehicles)
          ? state.vehicles.map((vehicle) =>
            vehicle.vehicle_id === action.payload.vehicle_id
              ? { ...vehicle, ...action.payload } 
              : vehicle
          )
          : [],
        message: 'Vehicle status updated successfully',
      };


    default:
      return state;
  }
}

